module.exports = __webpack_public_path__ + "static/media/Revv_Metalens_Revised_GIF.2ed51096.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Revv_Metalens_Revised_GIF.gif
// module id = 2214
// module chunks = 17